import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import { CHAT_AVATAR_URL } from 'containers/Chat/Api';

import { FirebaseMain } from '../firebase';
import firebaseNode from '../firebaseNode';


const RESET_STATE = 'cam4/firebaseWatchers/privateChatState/RESET_STATE';
const SET_INITIAL_THREADS = 'cam4/firebaseWatchers/privateChatState/SET_INITIAL_THREADS';
const SET_THREAD_LIST = 'cam4/firebaseWatchers/privateChatState/SET_THREAD_LIST';
const ADD_NEW_THREAD = 'cam4/firebaseWatchers/privateChatState/ADD_NEW_THREAD';
const SET_CURRENT_THREAD = 'cam4/firebaseWatchers/privateChatState/SET_CURRENT_THREAD';
const UPDATE_CURRENT_THREAD = 'cam4/firebaseWatchers/privateChatState/UPDATE_CURRENT_THREAD';
const SET_MESSAGES = 'cam4/firebaseWatchers/privateChatState/SET_MESSAGES';
const SET_HAS_NEW = 'cam4/firebaseWatchers/privateChatState/SET_HAS_NEW';
const ADD_PRIVATE_CHAT_MESSAGE = 'cam4/firebaseWatchers/privateChatState/ADD_PRIVATE_CHAT_MESSAGE';

export const NAME = 'privateChat';

const initialState = Immutable.fromJS({
  threads: [],
  threadList: [],
  currentRecipient: {
    username: '',
    isFan: false,
  },
  messages: [],
  hasNew: false,
});

let isLoaded = false;
const newThread = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_INITIAL_THREADS:
      return state.set('threads', action.threads);
    case ADD_NEW_THREAD:
      newThread[action.thread] = {
        isFan: false,
        messages: [],
      };

      return state
        .set('threads', [newThread, ...state.get('threads')])
        .set('threadList', [action.thread, ...state.get('threadList')]);
    case SET_THREAD_LIST:
      return state.set('threadList', action.threads);
    case SET_CURRENT_THREAD:
      isLoaded = true;

      return state.set('currentRecipient', action.thread);
    case UPDATE_CURRENT_THREAD:
      return state.set('currentRecipient', action.thread);
    case SET_MESSAGES:
      return state.set('messages', action.messageList);
    case SET_HAS_NEW:
      return state.set('hasNew', action.value);
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

const threads = (state) => state[NAME].get('threads');
const threadList = (state) => state[NAME].get('threadList');
const currentRecipient = (state) => state[NAME].get('currentRecipient');
const messages = (state) => state[NAME].get('messages');
const hasNew = (state) => state[NAME].get('hasNew');

function stateToInitialValues() {
  return { type: RESET_STATE };
}

function populateCurrentThread(thread) {
  return {
    type: SET_CURRENT_THREAD,
    thread,
  };
}

function addNewThread(thread) {
  return {
    type: ADD_NEW_THREAD,
    thread,
  };
}

function changeCurrentThread(thread) {
  return {
    type: UPDATE_CURRENT_THREAD,
    thread,
  };
}

function populateThreads(threads) {
  return {
    type: SET_INITIAL_THREADS,
    threads,
  };
}

function populateThreadList(threads) {
  return {
    type: SET_THREAD_LIST,
    threads,
  };
}

function populateMessages(messageList) {
  return {
    type: SET_MESSAGES,
    messageList,
  };
}

function addPrivateMessage(message) {
  return {
    type: ADD_PRIVATE_CHAT_MESSAGE,
    message,
  };
}

function setHasNew(value) {
  return {
    type: SET_HAS_NEW,
    value,
  };
}

function prepareMessages(data, nextThread) {
  const threadList = [];
  let messageList = [];
  const recipient = {
    username: '',
    isFan: false,
  };
  if (typeof nextThread === 'string' || nextThread === null) {
    for (const [index, [thread]] of Object.entries(Object.entries(data))) {
      if (nextThread && typeof data[nextThread] !== 'undefined') {
        messageList = data[nextThread].messages;
        recipient.username = nextThread;
        recipient.isFan = data[nextThread].isFan;
      } else if (index === 0) {
        messageList = data[thread].messages;
        recipient.username = thread;
        recipient.isFan = data[thread].isFan;
      }
      threadList.push(thread);
    }
  }

  return { threadList, messageList, recipient };
}

function parseThreads(data, username) {
  const items = Object.values(data);

  return items.reduce((threadsSoFar, { m, mh, recipient, sender, tm, fc }) => {
    const key = username.toLowerCase() === recipient.toLowerCase() ? sender : recipient;
    if (!threadsSoFar[key]) {
      threadsSoFar[key] = {
        isFan: fc === 1,
        messages: [],
      };
    }
    threadsSoFar[key].messages.push({
      msgId: mh,
      message: m,
      sender,
      avatar: CHAT_AVATAR_URL.replace('{username}', sender),
      timestamp: tm,
    });

    return threadsSoFar;
  }, {});
}

function watchPrivateThreads(roomName, username) {
  const privateChatRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/privateMessages/${username}`);

  return (dispatch) => {
    privateChatRef.on('value', (snapshot) => {
      if (snapshot.val()) {
        const data = Object.values(snapshot.val());
        let nextThread = null;
        if (isLoaded && data && data.length > 0) {
          const { sender } = data[data.length - 1];
          const { recipient } = data[data.length - 1];
          if (recipient.toLowerCase() === username) {
            nextThread = sender;
          } else {
            nextThread = recipient;
          }
          dispatch(setHasNew(true));
        }

        const parsedThreads = parseThreads(data, username);
        const { threadList, messageList, recipient } = prepareMessages(parsedThreads, nextThread);
        dispatch(populateMessages(messageList));
        dispatch(populateCurrentThread(recipient));
        // TODO: add blink thread with new message ^
        dispatch(populateThreadList(threadList));
        dispatch(populateThreads(parsedThreads));
      }
    });
  };
}

function addMessage(message) {
  return (dispatch) => {
    dispatch(addPrivateMessage(message));
  };
}

export function changeThread(data, next) {
  return (dispatch) => {
    const { messageList, recipient } = prepareMessages(data, next);
    dispatch(changeCurrentThread(recipient));
    dispatch(populateMessages(messageList));
  };
}

export function addThread(newThread) {
  return (dispatch) => {
    const messageList = [];
    const recipient = {
      username: newThread,
      isFan: false,
    };
    dispatch(addNewThread(newThread));
    dispatch(changeCurrentThread(recipient));
    dispatch(populateMessages(messageList));
  };
}

function resetPrivateChat() {
  return (dispatch) => {
    dispatch(stateToInitialValues());
  };
}

export function updateHasNew(value) {
  return (dispatch) => {
    dispatch(setHasNew(value));
  };
}

export const selector = createStructuredSelector({
  privateChatData: createStructuredSelector({
    threads,
    threadList,
    messages,
    currentRecipient,
    hasNew,
  }),
});

export const actionCreators = {
  watchPrivateThreads,
  resetPrivateChat,
  addMessage,
  changeThread,
  addThread,
  updateHasNew,
};
